<template>
  <div>
    <BlockContainer v-if="weeks" :title="$t('mealPlan.subTitle.view')">
      <ul class="meal-plan-links">
        <li
            v-for="(week, index) in weeks"
            :key="index"
        >
          <Link
              :href="getUrl(week)"
              :aria-label="$t('mealPlan.label.view', getWeekLabelPlaceholders(week))"
              class="meal-plan-link"
              lg
              target="_blank"
          >
            {{ $t('mealPlan.label.view', getWeekLabelPlaceholders(week)) }}
          </Link>
        </li>
      </ul>
    </BlockContainer>
  </div>
</template>

<script>
import Link from "@/components/actions/Link.vue";
import { useShopStore } from "@/stores/shop";
import { useAppStore } from "@/stores/app";
import {getCurrentWeekdays, addDays, formatFullDate} from "@/utils/dateUtils";
import BlockContainer from "@/components/layout/BlockContainer.vue";
import {useLocaleStore} from "../../../stores/locale";

export default {
  components: {BlockContainer, Link },
  inject: ["setPageMetaTitle"],
  data() {
    return {
      weeks: [],
      numWeeks: window.config.MEAL_PLAN.view.weeks,
    };
  },
  setup() {
    const appStore = useAppStore();
    const shopStore = useShopStore();
    const localeStore = useLocaleStore();
    return { appStore, shopStore, localeStore };
  },
  async created() {
    await this.setPageMetaTitle(this.shopStore.name);
    this.prepare();
  },
  methods: {
    getUrl(week) {
      const endpointPath = new URL("TCPShowMealPlansJ.action", window.config.API_BASE).pathname;
      const devBaseUrl = window.config?.MEAL_PLAN?.view?.devBaseUrl;
      const baseUrl = process.env.NODE_ENV === "development"
        ? (devBaseUrl || "http://localhost:8780/")
        : window.config.API_BASE;
      const requestUrl = new URL(endpointPath, baseUrl);

      requestUrl.searchParams.set("json", "true");
      requestUrl.searchParams.set("dateFrom", week.start);
      requestUrl.searchParams.set("dateTo", week.end);
      requestUrl.searchParams.set("shopId", this.shopStore.wondId);
      requestUrl.searchParams.set("useIcons", "true");
      requestUrl.searchParams.set("langISO", this.localeStore.getLanguageCode);
      return requestUrl.toString();
    },
    prepare() {
      this.weeks = [];
      let currentDate = new Date();

      for (let i = 0; i < this.numWeeks; i++) {
        const weekdays = getCurrentWeekdays(currentDate, window.config.MEAL_PLAN.weekDays);
        this.weeks.push({ start: weekdays[0], end: weekdays[weekdays.length - 1] });
        currentDate = addDays(currentDate, 7);
      }
    },
    getWeekLabelPlaceholders(week) {
      return [formatFullDate(week.start), formatFullDate(week.end)];
    },
  },
};
</script>

<style scoped>
.meal-plan-links {
  list-style: none;
  margin: 0;
  padding: 0;
}

.meal-plan-links li + li {
  margin-top: 8px;
}

.meal-plan-link {
  display: inline-flex;
  align-items: center;
  min-height: 24px;
  padding: 4px 0;
}
</style>
